import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import CompareViewModel from "../viewModel";
import { getMultiLangProperty } from "../../../helpers/generalHelper";

const AdditionalInfo = () => {
  const { t, i18n } = useTranslation();
  const { additionalInfo } = useContext(CompareViewModel.Context);
  return (
    <>
      {Array.isArray(additionalInfo) &&
        additionalInfo.map((column, columnIndex) => (
          <tr key={columnIndex}>
            <th className="title-column">
              {columnIndex === 0 ? t("compare.additionalInfo") : ""}
            </th>
            {Array.isArray(column) &&
              column.map(({ label, content }, rowIndex) => (
                <td key={rowIndex}>
                  <b>{getMultiLangProperty(label, i18n.language)}</b>
                  <div
                    style={{ textAlign: "start" }}
                    className="d-flex flex-column justify-content-start align-items-start html-content"
                    dangerouslySetInnerHTML={{
                      __html: getMultiLangProperty(content, i18n.language),
                    }}
                  />
                </td>
              ))}
          </tr>
        ))}
    </>
  );
};

export default AdditionalInfo;
